import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { IncomeTypesEnum } from 'src/app/shared/enums/income-types.enum';
import { NumerairesEnum } from 'src/app/shared/enums/numeraires.enum';
import { RecurrenceEnum, RecurrenceValueEnum } from 'src/app/shared/enums/recurrence.enum';
import { ClientModel } from 'src/app/shared/interfaces/client-model';
import { ClientService } from 'src/app/shared/services/client.service';

@Component({
  selector: 'app-income-dialog',
  templateUrl: './income-dialog.component.html',
  styleUrls: ['./income-dialog.component.scss']
})
export class IncomeDialogComponent implements OnInit {

  client = {} as ClientModel
  account_uuid: string
  formGroup: FormGroup
  currencyOption = { prefix: 'R$ ', thousands: '.', decimal: ',', suffix: '', precision: 2 }
  bsConfig = Object.assign({}, {
    containerClass: 'theme-default',
    adaptivePosition: true,
    isAnimated: true,
    dateInputFormat: 'DD/MM/YYYY'
  })
  confirmResult: Subject<any>
  listRecurrence: any = Object.keys(RecurrenceValueEnum).map(key => {
    return ({ value: RecurrenceValueEnum[key], name: RecurrenceEnum[key] })
  })
  incomeTypes: any = Object.keys(IncomeTypesEnum)
    .filter(k => isNaN(Number(k))); // remove índices numéricos

  constructor(
    private clientService: ClientService,
    public modalRef: BsModalRef,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.confirmResult = new Subject()
    this.clientService.clientData.subscribe(d => {
      if (!d) { return; }
      this.client = d;
    })
    this.loadForm()
  }

  loadForm() {
    this.formGroup = this.fb.group({
      currency: 'BRL',
      date_first_payment: moment().unix(),
      description: '',
      frequency: [0, Validators.required],
      name: 'Aporte',
      numeraire_asset_index_uuid: this.clientService.getNumeraires(NumerairesEnum.BRL),
      repetitions: [0, Validators.required],
      type: ['', Validators.required],
      value: [0, Validators.required]
    })
  }

  async submit() {
    if (this.formGroup.valid) {
      const $res = await this.clientService.saveIncome(this.formGroup.value, { rb_account_uuid: this.account_uuid })
      this.confirmResult.next($res.value)
      this.modalRef.hide()
    } else {
      this.formGroup.markAllAsTouched()
    }
  }

  get f() {
    return this.formGroup.controls
  }
}
